import type { UIInventoryItem, UIPartyCharacter } from '@sorrem-client/types';
import { EquipmentSummary } from '@sorrem-client/ui/features/ActionSlotSummary';
import { useCallback, type ReactNode } from 'react';
import { resolveCharacterHomeItemCard } from './character-home-item-moves';

/**
 * An item's card for the popover shown while the pointer rests on its slot
 * (#205): the card selecting it shows in the Inventory side panel, a carried
 * or stored item compared with what it would replace. None while no
 * character is loaded.
 */
export function useCharacterHomeItemDetails(character: UIPartyCharacter | null): (item: UIInventoryItem) => ReactNode {
    return useCallback((item: UIInventoryItem): ReactNode => {
        const card = character === null ? undefined : resolveCharacterHomeItemCard(character, item.id);
        return card === undefined ? null : <EquipmentSummary item={card.item} compared={card.compared} />;
    }, [character]);
}
